import { createFileRoute } from '@tanstack/react-router'
import { LandingPage } from '@/components/landing-page'

export const Route = createFileRoute('/')({
  component: LandingPage,
  head: () => ({
    meta: [
      { title: 'mkdn.app — collaborative markdown editor' },
      {
        name: 'description',
        content: 'A free collaborative markdown editor with real-time editing and sharing.',
      },
    ],
  }),
})
